export const Categeory = {
  Category: [
    ["Moisturizers", 2],
    ["Face Makeup", 4],
    ["Eye Care", 3],
    ["Blush", 3],
    ["Face Sun Care", 1],
    ["Lip Makeup", 2],
    ["Jouer Cosmetics", 2],
    ["Kevyn Aucoin", 1],
    ["Kjaer Weis", 5],
    ["Perricone MD", 1],
    ["RMS Beauty", 2],
    ["Smashbox", 2],
    ["Stila", 1],
    ["Supergoop!", 1],
    ["Tarte", 0],
    ["Vapour Beauty", 3],
  ],
  Makeup_Category: ["Lips", "Makeup", "Eyes", "Palettes", "Complexion"],
  Makeup_Product_Type: ["Blusher"],
  Complexion_Format: ["Cream", "Liquid", "Stick"],
  Complexion_Finish: ["Dewy", "Glossy", "Matte", "Satin"],
  Complexion_Coverage: ["Buildable", "Full", "Medium", "Sheer"],
  Cosmetics_TA: ["Brushes"],
  Cosmetics_BT: ["Lip"],
  Lips_Products: [
    "Lipstick",
    "Liquid Lipstick",
    "Lip Gloss",
    "Lip Stain & Tint",
    "Lip Plumper",
    "Tinted Lip Balm",
  ],
  Preferences: [
    "Certified Cruelty-Free",
    "Certified Organic",
    "Clean",
    "Fragrance-Free",
    "Gluten-Free",
    "Hypoallergenic",
    "Natural",
    "Non-Comedogenic",
    "Paraben-Free",
    "Phthalate-Free",
    "Sulfate-Free",
    "Vegan",
  ],
  Price: ["${10} - $2", `$25 - $50`],
  Savings: ["Up to 25%", "25% - 50%"],
  Average_Reviews: ["4+"],
};
